<template>
  <div>

    <div v-if="!infoCollected">

      <v-container grid-list-lg fill-height fluid class="pa-0">
        <v-stepper v-if="!infoCollected" vertical v-model="step" class="elevation-0">


          <v-stepper-step :complete="step > 1" step="1">
            Sponsor
          </v-stepper-step>
          <v-stepper-content step="1">
            <v-list dense class="py-0" v-for="(group, index) in group" :key="index">
              <v-subheader>{{ group.name }}</v-subheader>
              <v-list-item two-line v-for="(item, i) in group.items" :key="i">
                <v-list-item-action>
                  <v-btn depressed color="primary" @click="plus(item)" x-small fab>
                    <v-icon>mdi mdi-plus</v-icon>
                  </v-btn>
                </v-list-item-action>

                <v-list-item-content>
                  <v-list-item-title v-text="item.text"></v-list-item-title>
                  <v-list-item-subtitle class="caption">{{ item.qty }}x {{ item.amount | currency
                  }}</v-list-item-subtitle>
                </v-list-item-content>

                <v-list-item-action>
                  <v-btn depressed color="error" :disabled="item.qty === 0 ? true : false" @click="minus(item)" x-small
                    fab>
                    <v-icon>mdi mdi-minus</v-icon>
                  </v-btn>
                </v-list-item-action>

              </v-list-item>
            </v-list>

            <div class="text-center caption mt-2 red--text">
              <span class="font-weight-bold">{{ sponsorTotal / 12 | currency }}</span> each month for 12 months
            </div>



            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn :disabled="sponsorTotal === 0 ? true : false" @click="sponsorDone" color="primary">Next</v-btn>
            </v-card-actions>
          </v-stepper-content>


          <v-stepper-step :complete="step > 2" step="2">
            Payment Preferences
          </v-stepper-step>

          <v-stepper-content step="2">
            <v-col cols="12" class="py-2">
              <div class="mb-2">Payment Cycle?</div>
              <v-btn-toggle dense v-model="donationObj.paymentCycle" color="primary">
                <v-btn outlined small value="monthly">
                  Monthly
                </v-btn>

                <v-btn outlined small value="oneTime">
                  One Time
                </v-btn>

              </v-btn-toggle>
            </v-col>
            <v-col cols="12">
              <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" offset-y
                max-width="290px" min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field v-model="dateFormatted" outlined dense label="Starting Date" readonly hide-details
                    v-bind="attrs" @blur="startingDate = parseDate(dateFormatted)" v-on="on"></v-text-field>
                </template>
                <v-date-picker :min="minDate" v-model="startingDate" no-title @input="menu1 = false"></v-date-picker>
              </v-menu>
            </v-col>
            <v-col v-if="donationObj.paymentCycle === 'monthly'" cols="12" class="text-caption text-md-body-1 text-lg-h6">
              We will collect a payment of <span class="font-weight-bold">{{ sponsorTotal / 12 | currency }}</span> on the
              <span class="font-weight-bold">{{ getFormattedDay(startingDate) }}</span> day of each month for
              a 12-month
              cycle. Starting from <span class="font-weight-bold">{{ startingDate | moment('LL') }}</span>. At
              the end of
              the 12-month cycle, your sponsorship will come to a close.
            </v-col>
            <v-col v-else cols="12" class="text-caption text-md-body-1 text-lg-h6">
              We will collect a payment of <span class="font-weight-bold">{{ sponsorTotal | currency }}</span> on the
              <span class="font-weight-bold">{{ startingDate | moment('LL') }}</span>. for whole year of
              sponsorship.
            </v-col>
            <v-divider></v-divider>
            <v-card-actions>
              <v-btn text @click="step = step - 1">Back</v-btn>
              <v-spacer></v-spacer>
              <v-btn @click="preferencesDone" color="primary">next</v-btn>
            </v-card-actions>
          </v-stepper-content>

          <v-stepper-step :complete="step > 3" step="3">
            Payment Method
          </v-stepper-step>

          <v-stepper-content step="3">
            <v-card class="mx-auto" flat max-width="600">
              <div outlined class="mt-2">
                <v-card-text>
                  <v-row>
                    <v-col cols="12" sm="12" md="12">
                      <v-text-field autofocus outlined dense :error-messages="nameErrors"
                        :background-color="`${sponsor.name ? false : '#E8F5E9'}`" :hide-details="nameErrors.length === 0"
                        v-model.trim="sponsor.name" label="Full Name">
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="12">
                      <v-text-field outlined dense v-mask="'(###) ###-####'" type="tel"
                        :background-color="`${sponsor.phoneNumber ? false : '#E8F5E9'}`" :error-messages="phoneNumberErrors"
                        :hide-details="phoneNumberErrors.length === 0" v-model="sponsor.phoneNumber"
                        label="Phone Number"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="12">
                      <v-text-field outlined dense :background-color="`${sponsor.email ? false : '#E8F5E9'}`"
                        :error-messages="emailErrors" :hide-details="emailErrors.length === 0" v-model="sponsor.email"
                        label="Email Address"></v-text-field>
                    </v-col>
                  </v-row>
                  <CreditCard v-if="Business" @submit="collectCard" :hideBank="true" :autofocus="false" :localCollectOnly="true"
                    :donationCategoryId="Business.DefaultDonationId" :public="true" />
                </v-card-text>
              </div>
            </v-card>
            <v-divider class="mt-4"></v-divider>
            <v-card-actions>
              <v-btn text @click="step = step - 1">Back</v-btn>
              <v-spacer></v-spacer>
              <v-btn @click="cardDone" :loading="cardLoading" color="primary">next</v-btn>
            </v-card-actions>
          </v-stepper-content>

          <v-stepper-step :complete="step > 4" step="4">
            Complete
          </v-stepper-step>

          <v-stepper-content step="4">
            <v-card-text>
              <v-col v-if="donationObj.paymentCycle === 'monthly'" cols="12"
                class="text-caption text-md-body-1 text-lg-h6">
                We will collect a payment of <span class="font-weight-bold">{{ sponsorTotal / 12 | currency }}</span> on
                the
                <span class="font-weight-bold">{{ getFormattedDay(startingDate) }}</span> day of each month for
                a 12-month
                cycle. Starting from <span class="font-weight-bold">{{ startingDate | moment('LL') }}</span>. At
                the end of
                the 12-month cycle, your sponsorship will come to a close.
              </v-col>
              <v-col v-else cols="12" class="text-caption text-md-body-1 text-lg-h6">
                We will collect a payment of <span class="font-weight-bold">{{ sponsorTotal | currency }}</span> on the
                <span class="font-weight-bold">{{ startingDate | moment('LL') }}</span>. for whole year of
                sponsorship.
              </v-col>
              <!-- <p class="caption">By pressing submit button i am allowing Muhammadi Masjid to collect 300 Monthly till
                4/2/2023 </p> -->

              <v-btn block :loading="loadingSubmit" color="primary" @click="submit">
                Submit
              </v-btn>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-btn large block text @click="step = step - 1">Back</v-btn>
              <!-- <v-spacer></v-spacer> -->
              <!-- <v-btn @click="studentDone" v-if="takeCard" color="primary" large>next</v-btn> -->
              <!-- <v-btn @click="submitWithOutCard" :loading="loading" color="primary" large>Submit</v-btn> -->
            </v-card-actions>
          </v-stepper-content>

        </v-stepper>
      </v-container>
    </div>

    <div v-else>
      <v-card-text>
        <lottie :height="200" :options="defaultOptions" name="receiptCheck" v-on:animCreated="handleAnimation" />
        <div class="text-center">
          <div class="text-h5">All Set</div>
          <div class="mt-3">We will contact you soon insh Allah.</div>
        </div>
      </v-card-text>
    </div>

    <v-footer class="padless" app>
      <v-col class="text-center pa-0" cols="12">
        {{ version }} — <span>Power by: </span><strong>taleem.app</strong>
      </v-col>
    </v-footer>
  </div>
</template>


<script>
import applicationService from "@/modules/Application/service.js";
const { validationMixin } = require("vuelidate");
const { required, email } = require("vuelidate/lib/validators");
import Lottie from "@/components/lottie.vue";
// import GlobalFunction from "@/mixins/GlobalFunction";
import * as animationData from "@/assets/lottie/1708-success.json";
const pjson = require("../../../../package.json");
// import Stripe from 'stripe';
import CreditCard from '@/modules/PaymentMethod/components/CreditCard.vue'


export default {
  name: "sponsor-page",
  props: ['currentBusiness', 'takeCard'],
  data() {
    return {
      cardLoading: false,
      loadingSubmit: false,
      token: null,
      // stripePublicKey: process.env.VUE_APP_STRIPE_PK,
      dateFormatted: null,
      minDate: null,
      menu1: false,
      step: 1,
      donor: null,
      infoCollected: false,
      openTermBox: false,
      loading: false,
      Business: null,
      complete: false,

      defaultOptions: {
        animationData: animationData.default,
        loop: false,
        autoplay: true,
      },
      startingDate: null,
      group: [
        {
          name: 'Hifz School',
          items: [
            {
              text: 'Boys Hifz Sponsor',
              amount: '1200',
              qty: 0,
              stripeProductId: 'prod_LZsCZmsDtedy5z',
              ProductId: 1,
            },
            {
              text: 'Girls Hifz Sponsor',
              amount: '1200',
              qty: 0,
              stripeProductId: 'prod_LZsCZmsDtedy5z',
              ProductId: 1,
            },
          ],
        },
        {
          name: 'Maktab School',
          items: [
            {
              text: 'Boys Maktab Sponsor',
              amount: '600',
              qty: 0,
              stripeProductId: 'prod_LaZiku6ufPhTcW',
              ProductId: 2,
            },
            {
              text: 'Girls Maktab Sponsor',
              amount: '600',
              qty: 0,
              stripeProductId: 'prod_LaZiku6ufPhTcW',
              ProductId: 2,
            },
          ],
        }
      ],
      model: 1,
      sponsor: {
        phoneNumber: null,
        name: null,
        email: null,
      },
      card: {},
      Donation: {},
      donationObj: {
        paymentType: 'card',
        paymentCycle: 'monthly',
        accountType: 'personal',
        startingDate: null,
      }
    };
  },
  mixins: [validationMixin],
  validations: {
    sponsor: {
      phoneNumber: {
        required,
      },
      name: {
        required,
      },
      email: {
        required,
        email,
      },
    },
  },
  computed: {
    sponsorTotal() {
      let total = 0
      this.group.map(row => {
        row.items.map(item => {
          if (item.qty != 0) {
            total += item.qty * item.amount
          }
        })
      })
      return total
    },
    version() {
      return pjson.version;
    },
    nameErrors() {
      const errors = [];
      if (!this.$v.sponsor.name.$dirty) return errors;
      if (!this.$v.sponsor.name.required) errors.push("Name is required");
      return errors;
    },
    phoneNumberErrors() {
      const errors = [];
      if (!this.$v.sponsor.phoneNumber.$dirty) return errors;
      if (!this.$v.sponsor.phoneNumber.required)
        errors.push("Phone Number is required");
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.sponsor.email.$dirty) return errors;
      if (!this.$v.sponsor.email.required)
        errors.push("Email Address is required");
      if (!this.$v.sponsor.email.email)
        errors.push("Please enter a valid email address");
      return errors;
    },
  },
  components: {
    Lottie,
    CreditCard
  },
  created() {
    // let a = "(718) 299-2222";

    // let st = a.replace(/[^a-zA-Z0-9]/g, "");

    // console.log("test test", st);
    this.loadBusiness();
    this.startingDate = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)
    this.dateFormatted = this.formatDate((new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10))
    this.minDate = this.$moment(this.Donation.startingDate).format('YYYY-MM-DD');
    this.Business = this.currentBusiness

  },
  watch: {
    startingDate() {
      this.dateFormatted = this.formatDate(this.startingDate)
    },
    currentBusiness(val) {
      this.StripeKey = val.metadata.publicStripeId;
      this.Classes = val.Classes;
    }
  },
  methods: {
    collectCard(donationDetail){
      this.donationObj.accountType = donationDetail.accountType
      this.donationObj.paymentType = donationDetail.paymentType
      this.donationObj.donationCategoryId = donationDetail.donationCategoryId
      this.card = donationDetail.card
      this.step = 4
    },
    // createToken(card) {
    //   // this.cardLoading = true
    //   console.log('card', card)
    //   applicationService.publicCreateStripeToken(card).then((response) => {
    //     console.log('token', response)
    //     this.token = response.id;

    //     this.cardLoading = false
    //     return response.id
    //   }).catch(error => {
    //     console.log('error', error)
    //     throw error
    //   })
    // },
    async cardDone() {
      this.$v.sponsor.$touch()
      if (this.$v.sponsor.$invalid) {
        this.$swal
        .mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
        })
        .fire({
          icon: "error",
          title: this.$t("toastMessage.text.invalidFields"),
        });
      }
      this.$events.emit("submitCreditCard");
    },
    getFormattedDay(date) {
      const dayOfMonth = this.$moment(date).date();
      const suffix = this.getDaySuffix(dayOfMonth);
      return dayOfMonth + suffix;
    },
    getDaySuffix(day) {
      if (day >= 11 && day <= 13) {
        return "th";
      }
      switch (day % 10) {
        case 1:
          return "st";
        case 2:
          return "nd";
        case 3:
          return "rd";
        default:
          return "th";
      }
    },

    formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${month}/${day}/${year}`
    },
    parseDate(date) {
      if (!date) return null

      const [month, day, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    plus(item) {
      item.qty += 1
    },
    minus(item) {
      item.qty -= 1
    },
    preferencesDone() {
      this.step = 3
    },
    sponsorDone() {
      this.step = 2
    },
    handleAnimation(anim) {
      this.anim = anim;
    },
    loadBusiness() {
      let id = this.$route.params.id;
      console.log("id", id);
      applicationService
        .getBusinessInformation({ key: id })
        .then((response) => {
          console.log("response", response);
          this.Business = response.data;
          // this.Classes = this.Business.Classes;
        })
        .catch((error) => {
          console.log("error", error);
          this.$router.push({ name: "pagenotfound" });
        });
    },
    deleteItem(item) {
      this.Students.splice(this.Students.indexOf(item), 1);
      // this.editedIndex = this.Students.indexOf(item)
      // this.editedItem = Object.assign({}, item)
      // this.dialogDelete = true
    },
    // submitWithOutCard() {
    //   console.log('submitWithOutCard')
    //   if (this.Students.length === 0) {
    //     this.$swal
    //       .mixin({
    //         toast: true,
    //         position: "top-end",
    //         showConfirmButton: false,
    //         timer: 3000,
    //       })
    //       .fire({
    //         icon: "error",
    //         title: "Please add student",
    //       });
    //   } else {
    //     this.submit()
    //   }
    // },
    async submit() {
      // const data = await createToken();
      // this.$v.Lead.$touch();
      // if (this.$v.Lead.$invalid) {
      //   this.$swal
      //     .mixin({
      //       toast: true,
      //       position: "top-end",
      //       showConfirmButton: false,
      //       timer: 3000,
      //     })
      //     .fire({
      //       icon: "error",
      //       title: this.$t("toastMessage.text.invalidFields"),
      //     });
      // } else {
      // if (this.Students.length === 0) {
      //   this.$swal
      //     .mixin({
      //       toast: true,
      //       position: "top-end",
      //       showConfirmButton: false,
      //       timer: 4000,
      //     })
      //     .fire({
      //       icon: "error",
      //       title: "Please Enter Student",
      //     });
      //   this.loading = false;
      //   this.dialog = true;
      // }
      try {
        this.loadingSubmit = true;
        const selectedItems = [];
        for (const group of Object.values(this.group)) {
          for (const item of group.items) {
            if (item.qty > 0) {
              selectedItems.push({
                ...item,
                name: item.text,
                price: item.amount,
                ProductId: item.ProductId,
              });
            }
          }
        }
        //  this.Lead.students = this.Students;
        if (this.sponsor.phoneNumber) {
          this.sponsor.phoneNumber = this.sponsor.phoneNumber.replace(
            /[^a-zA-Z0-9]/g,
            ""
          );
        }

        this.Donation = {
          sponsor: this.sponsor,
          card: this.card,
          donationObj: this.donationObj,
          business: this.Business,
          selectedItems: selectedItems
        }
        this.Donation.donationObj.startingDate = this.startingDate
        console.log("this.Students.length", this.currentBusiness, this.Donation);
        this.loadingSubmit = true;
        applicationService
          .publicSponsorCreate(this.Business.code, this.Donation)
          .then(() => {
            // console.log("response", response);
            this.infoCollected = true;
            this.loadingSubmit = false;
          })
          .catch((err) => {
            this.loadingSubmit = false;
            console.log("err", err);
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              })
              .fire({
                icon: "error",
                title: err.message,
              });
          });
        // this.loading = false;
      } catch (error) {
        this.loadingSubmit = false;
        console.log("error adding card", error);
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: error.message,
          });
      }
    }
  },
  // },
};
</script>

<style scoped>
.centerdiv {
  position: relative;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;

  margin: auto;
}
</style>